import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { businessInfo } from '../mock/mockData';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_garage-revival-1/artifacts/qg6evl0p_FullLogo_NoBuffer.jpg" 
              alt="Space Specialists Logo" 
              className="h-12 w-auto"
            />
            <div className="text-2xl font-bold text-slate-800">
              Space <span className="text-blue-600">Specialists</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-slate-700 hover:text-blue-600 transition-colors font-medium"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-slate-700 hover:text-blue-600 transition-colors font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('packages')}
              className="text-slate-700 hover:text-blue-600 transition-colors font-medium"
            >
              Packages
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="text-slate-700 hover:text-blue-600 transition-colors font-medium"
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="text-slate-700 hover:text-blue-600 transition-colors font-medium"
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-slate-700 hover:text-blue-600 transition-colors font-medium"
            >
              Contact
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <a href={`tel:${businessInfo.phoneRaw}`} className="flex items-center space-x-2 text-slate-700 hover:text-blue-600 transition-colors">
              <Phone className="h-4 w-4" />
              <span className="font-semibold">{businessInfo.phone}</span>
            </a>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              Get Free Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-slate-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden pb-6 space-y-4">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left text-slate-700 hover:text-blue-600 transition-colors font-medium py-2"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-slate-700 hover:text-blue-600 transition-colors font-medium py-2"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('packages')}
              className="block w-full text-left text-slate-700 hover:text-blue-600 transition-colors font-medium py-2"
            >
              Packages
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="block w-full text-left text-slate-700 hover:text-blue-600 transition-colors font-medium py-2"
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left text-slate-700 hover:text-blue-600 transition-colors font-medium py-2"
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-slate-700 hover:text-blue-600 transition-colors font-medium py-2"
            >
              Contact
            </button>
            <a href={`tel:${businessInfo.phoneRaw}`} className="flex items-center space-x-2 text-blue-600 font-semibold py-2">
              <Phone className="h-4 w-4" />
              <span>{businessInfo.phone}</span>
            </a>
            <Button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white"
            >
              Get Free Quote
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};
